import { take } from 'rxjs/operators';
import { FbLeaveApprovalStatusDashboardCardService } from './fb-leave-approval-status-dashboard-card.service';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CustomButtonActionService } from 'custom-button-action';
import { FormDesignerService } from '../../form-designer/form-designer.service';

@Component({
  selector: 'app-fb-leave-approval-status-dashboard-card',
  templateUrl: './fb-leave-approval-status-dashboard-card.component.html',
  styleUrls: ['./fb-leave-approval-status-dashboard-card.component.scss']
})
export class FbLeaveApprovalStatusDashboardCardComponent implements OnChanges {
  @Input() content: {
    type: string,
    title: string,
    footerLink: string,
    dashboardRedirectPageFormId?: number
  };
  leaveAprrovalList: any[];
  private readonly MONTH_NAMES = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];

  constructor(
    private fbLeaveApprovalStatusDashboardCardService: FbLeaveApprovalStatusDashboardCardService,
    private customButtonActionService: CustomButtonActionService,
    private formDesignerService: FormDesignerService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.content) {
      this.fetchDetails();
    }
  }

  fetchDetails() {
    if (this.content) {
      this.fbLeaveApprovalStatusDashboardCardService.fetchDetails()
        .pipe(take(1))
        .subscribe((leaveAprrovalList: any[]) => {
          this.leaveAprrovalList = leaveAprrovalList.map(x => {
            const profilePicBase64 = x['smallProfilePic'];
            return {
              ...x,
              dateRange: this.convertDateRangeToString(x),
              profilePicBase64: profilePicBase64
              ? `data:image/jpeg;base64,${profilePicBase64}`
              : null
            }
          });
        });
    }
  }

  private convertDateRangeToString(dateRange: any): string {
    const fromDate = new Date(dateRange.fromDate);
    const toDate = new Date(dateRange.toDate);

    const fromDateString = `${fromDate.getDate()} ${this.MONTH_NAMES[fromDate.getMonth()]}`;
    const toDateString = `${toDate.getDate()} ${this.MONTH_NAMES[toDate.getMonth()]}`;

    return `Date: ${fromDateString} to ${toDateString}`;
  }

  footerRedirect() {
    sessionStorage.removeItem('redirectId');
    sessionStorage.setItem('redirectId', this.content.dashboardRedirectPageFormId.toString());
    this.formDesignerService.setDashboardLink(true);
    this.customButtonActionService.getPageFormById(this.content.dashboardRedirectPageFormId)
      .pipe(take(1)).subscribe((response: any) => {
        if (response) {
          const item = {
            formType: response.buildFormatTypeId,
            pageFormId: response.id
          }
          // if (this.isBeneficiaryProfileListing) {
          //   sessionStorage.setItem('FbEmployeeId', rowData.fb_beneficiaryId);
          //   sessionStorage.setItem('FbActualEmployeeId', rowData.fb_employeeId);
          // } else {
          // sessionStorage.setItem('formDataId', rowData.id);
          // }
          this.customButtonActionService.onLinkRedirectPageSubject.next(item);
        }
      });
  }

}
